import { Button } from 'antd'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { Link } from 'react-router-dom'

const CheckboxTable = checkboxHOC(CustomTable)

function ReadyToOrderList(props) {
  const {
    isSelected,
    toggleSelection,
    tableRef,
    selection,
    filteredData,
    fetch,
    fetching,
    onShow,
    company,
    onChangeCompany,
    selectAll,
    toggleAll,
    completing,
    complete,
  } = props

  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }

  const columns = [
    { Header: 'ID', accessor: '_id', width: 150, hideable: true, hideDefault: true },
    {
      Header: 'Code',
      accessor: 'reqs.code',
      width: 100,
      Cell: ({ value, original }) => (
        <Link
          target={'_blank'}
          to={`/purchasing/requisitions/${
            original.reqs._key ? original.reqs._key : original.reqs._id.replace('reqs/', '')
          }/update`}>
          {value}
        </Link>
      ),
    },
    { Header: 'No', accessor: 'no', width: 100, hideable: true, hideDefault: false },
    { Header: 'GROUP', accessor: 'groupLink', width: 100, hideable: true, hideDefault: false },
    {
      Header: 'Name',
      accessor: 'budgetLine.name',
      //width: 350,
      style: { paddingLeft: 10, alignment: 'left' },
    },
    { Header: 'Sales Order', accessor: 'sales.code', width: 100, hideable: true },
    { Header: 'Center', accessor: 'budgetLine.centers.name', hideable: true, hideDefault: true },
    { Header: 'Vendor', accessor: 'vendor.fn', width: 350, hideable: true, hideDefault: true },
    { Header: 'Currency', accessor: 'currency', width: 100, hideable: true, hideDefault: true },
    { Header: 'Quantity', accessor: 'unit', width: 100, hideable: true },
    { Header: 'Uom', accessor: 'uom.code', width: 100, hideable: true },
    {
      Header: 'Ordered',
      accessor: 'ordered',
      width: 100,
      hideable: true,
      hideDefault: true,
    },
    { Header: 'Type', accessor: 'orderType[0]', width: 100 },
    { Header: 'Category', accessor: 'orderType[1]', width: 130 },
    {
      Header: 'Max',
      accessor: 'max',
      width: 100,
      hideable: true,
      hideDefault: true,
    },
  ]
  return (
    <CheckboxTable
      {...checkboxProps}
      withRef={tableRef}
      data={filteredData}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      columns={columns}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={company}
          onChange={onChangeCompany}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{ width: '450px', paddingRight: 20, float: 'right' }}
        />
      )}
      CreateButton={() => (
        <>
          <Button type={'primary'} size="small" icon={'plus'} disabled={selection.length === 0} onClick={onShow}>
            Create New Order
          </Button>
          <Button
            size={'small'}
            type={'danger'}
            loading={completing}
            onClick={complete}
            disabled={selection.length === 0}
            style={{ marginLeft: '10px' }}>
            Mark As Completed
          </Button>
        </>
      )}
      defaultSorted={[
        {
          id: 'date',
          desc: true,
        },
      ]}
      style={{ minHeight: '512px', fontSize: 11 }}
    />
  )
}

ReadyToOrderList.propTypes = {}
ReadyToOrderList.defaultProps = {}

export default ReadyToOrderList
